<template>
    <section class="section">
        <div class="container">
                    <br>
                    <h3 class="is-size-1 has-text-primary section-title">The WebBank Difference</h3>
                    <br>
            <div class="columns">
                <div class="column is-half">
                    <br>
                    <br>
                    <div class="content">
                        <p class="">In WebBank's decades long role as "The Bank Behind the Brand<sup>&reg;</sup>, we have worked with premier non-bank
                            financial technology companies, many of which are now household names, to provide unique specialty finance business models
                            and solutions. Our decades of experience and unparalleled access to leading fintech companies enables us to provide creative
                            solutions to bespoke platforms ranging from VC-backed startups to Fortune 50 companies.  Working with WebBank, fintech and
                            specialty finance companies can attain bank-level pricing for structured credit facilities that traditionally have only been
                            provided by much higher cost credit funds and non-bank direct lenders.</p>
                        <br>
                        <p>Given our work with diverse specialty finance platforms, we are experts in a wide variety of consumer and SMB asset classes,
                            including equipment-backed finance, unsecured consumer loans (including Buy Now Pay Later), MCA, credit card receivables,
                            supply chain finance, installment loans, and dealer floorplan lines, just to name a few.  More importantly, our approach and
                            mindset allow us to tailor customized, asset-based solutions for newer platforms with specialty assets seeking lower cost options
                            as portfolios season.</p>
                        <br>
                        <p>Whether you're an entrepreneur with a specialty finance business seeking growth capital greater than $10 million, a broker-dealer
                            advising specialty finance companies on funding options for their receivables, or a credit fund portfolio manager seeking leverage
                            for your existing, asset-based investments, contact us and let's discuss how we can work together.</p>
                    </div>
                    <br>
                </div>
                <div class="column">
                    <br>
                    <br>
                    <img src="https://assets.webbank.com/R5_C1616.png" class="body-image" alt="Asset Finance at WebBank" />
                </div>
            </div>

            <hr>
            <br>
            <br>

    <section class="section" v-if="success">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2 has-text-centered">
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <span class="icon has-text-success"><i class="fa-solid fa-badge-check fa-10x"></i></span>
                    <br>
                    <br>
                    <br>
                    <br>
                    <p class="has-text-success is-size-3">Thank you! Your message has been sent!</p>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </section>

            <div class="columns" v-else>
                <div class="column is-8 is-offset-2">
                    <div class="has-text-centered">
                    <h3 class="is-size-1 has-text-primary section-title">Asset Finance</h3>
                    <br>
                    <p>Asset Finance from WebBank helps customers get the capital they need to finance business growth.</p>
                    </div>
                    <br>
                    <br>

            <div class="notification is-danger" v-if="this.errors.length">
                Please check your input and try again.
            </div>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">First Name</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('first_name')}"
                                        type="text"
                                        name="first_name"
                                        placeholder="John"
                                        v-model="form.first_name">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('first_name')">Please enter your first name.</p>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Last Name</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('last_name')}"
                                        type="text"
                                        name="last_name"
                                        placeholder="Doe"
                                        v-model="form.last_name">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('last_name')">Please enter your last name.</p>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                <div class="field">
                    <label class="label">Email</label>
                    <div class="control has-icons-left has-icons-right">
                        <input class="input"
                            type="email"
                            name="email"
                            :class="{'is-danger': this.errors.includes('email')}"
                            placeholder="me@mycompany.com"
                            v-model="form.email">
                        <span class="icon is-small is-left">
                            <i class="fas fa-envelope"></i>
                        </span>
                    </div>
                    <p class="help has-text-danger" v-if="this.errors.includes('email')">Please enter your email.</p>
                </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <label class="label">Phone</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('phone')}"
                                        type="tel"
                                        name="phone"
                                        placeholder="xxx-xxx-xxxx"
                                        v-maska:[options]
                                        v-model="form.phone">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('phone')">Please enter your phone number.</p>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">Company</label>
                                <div class="control">
                                    <input class="input"
                                        :class="{'is-danger': this.errors.includes('brand_partner')}"
                                        type="text"
                                        name="brand_partner"
                                        placeholder="My Company"
                                        v-model="form.brand_partner">
                                </div>
                                <p class="help has-text-danger" v-if="this.errors.includes('brand_partner')">Please enter your Company name.</p>
                            </div>
                        </div>
                    </div>

                    <div class="field">
                        <label class="label">Description of Opportunity</label>
                        <div class="control">
                            <textarea class="textarea"
                                :class="{'is-danger': this.errors.includes('description')}"
                                name="description"
                                placeholder="Additional Details"
                                v-model="form.description">
                            </textarea>
                        </div>
                        <p class="help has-text-danger" v-if="this.errors.includes('description')">Please enter a description.</p>
                    </div>

                    <div class="field is-grouped">
                        <div class="control">
                            <button class="button is-primary" @click="submitForm" :class="{'is-loading': sending}">Submit</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>

</template>

<script>
import axios from 'axios';
import { vMaska } from "maska"

export default {
    directives: { maska: vMaska },
    created() {
        document.title = "Asset Finance - WebBank";
    },

    data: function () {
        return {
            form: {
                form_name: 'specialty_finance',
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                brand_partner: null,
                description: null
            },
            sending: false,
            success: false,
            errors: [],
            options: {
                mask: "###-###-####",
                eager: false,
            }
        }
    },

    computed: {
        currentRouteName() {
            return this.$route.name;
        }
    },

    methods: {
        submitForm: function () {
            this.errors = [];
            this.sending = true;
            console.log('submitting form...');

            for (let x in this.form) {
                console.log('checking form field: ' + x);
                console.log('value: ' + this.form[x]);
                if (!this.form[x]) {
                    console.log('field has an error! - ' + x);
                    this.errors.push(x);
                }
            }
            if (this.errors.length) {
                console.log('failing with validation errors: ', this.errors);
                this.sending = false;
                return false;
            }

            let data = this.form;
            console.log('posting data: ' + JSON.stringify(data));
            axios.post(process.env.VUE_APP_MAIL_ENDPOINT, data)
                .then(result => {
                    console.log('result: ' + JSON.stringify(result));
                    this.success = true;
                }).finally(() => this.sending = false);
        }
    }
}
</script>
